import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  headerWrapper: {
    paddingBottom: theme.spacing(1)
  },
  titleWrapper: {
    paddingTop: 0
  }
}));

export default useStyles;
